const projekttraegerschaften = [
    { value: 'SICHERHEITSFORSCHUNG', text: 'Sicherheitsforschung' },
    { value: 'MEDIZINTECHNIK', text: 'Medizintechnik' },
    {value: 'MATERIALFORSCHUNG', text: 'Materialforschung'},
    {value: 'QUANTENSYSTEME', text: 'Quantensysteme'},
    {value: 'HOCHSCHULFORSCHUNG', text: 'Forschung an Fachhochschulem'},
    {value: 'INDUSTRIE4.0', text: 'Initiative Industrie 4.0'},
    { value: 'Trägerschaft1', text: 'Trägerschaft 1' }, // nur zum testen -> kommt später raus
    { value: 'Trägerschaft2', text: 'Trägerschaft 2' }, // nur zum testen -> kommt später raus
]

export default projekttraegerschaften;